import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DocumentPageFragment = { __typename?: 'Page', height?: number | null, width?: number | null };

export const DocumentPage = /*#__PURE__*/ gql`
    fragment DocumentPage on Page {
  height
  width
}
    ` as unknown as DocumentNode<DocumentPageFragment, unknown>;

        

        
export const useDocumentPageFragment = (
  input: string | Omit<UseFragmentOptions<DocumentPageFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Page' } };
    return input;
  })();

  return useFragment<DocumentPageFragment>({
    fragment: DocumentPage,
    fragmentName: 'DocumentPage',
    ...options,
  });
};
  
        